module.exports = __webpack_public_path__ + "static/media/Character22.d22e115e.png";